import React from 'react';

import { Modal, Button, Form, Input, Slider, DatePicker, Flex } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24
	}
};

export const FishboneBranchEditionModal = (props: any) => {
	const [form] = Form.useForm();
	const { t } = useTranslation();

	const handleFormSubmit = () => {
		console.log('handleFormSubmit');
		form.validateFields()
			.then((values) => {
				console.log('validated', values);
				props.onSave(values);
				props.onHide();
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo);
			});
	};

	const footer = (
		<div style={{ display: 'flex' }}>
			{props.onDelete && (
				<Button
					onClick={() => {
						props.onDelete(props);
					}}
					danger={true}
					style={{ marginRight: 'auto' }}
				>
					{t('actions.delete')}
				</Button>
			)}
			<Button
				onClick={() => {
					props.onHide();
				}}
				style={{ marginRight: 'auto' }}
			>
				{t('actions.close')}
			</Button>
			<Button onClick={handleFormSubmit} type="primary">
				{t('actions.save')}
			</Button>
		</div>
	);

	const isDisabledDate = (current) => {
		if (props.minDate && dayjs(current).isBefore(props.minDate))
			return true;
		if (props.maxDate && dayjs(current).isAfter(props.maxDate))
			return true;
		return false;
	};

	return (
		<Modal
			open={true}
			title={props.id ? t('models.fishbone_branch.actions.edit') : t('models.fishbone_branch.actions.add')}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText={t('actions.close')}
			footer={footer}
			maskClosable={false}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values);
					props.onHide();
				}}
				initialValues={props.values}
			>
				<Form.Item
					name="name"
					label={t('models.fishbone_branch.fields.name')}
					required={true}
					rules={[
						{
							max: 30,
							message:
								t("messages.form.max_length_exceeded_error", { length: 30 })
						},
						{
							required: true,
							message: t("messages.form.required_error")
						}
					]}
				>
					<Input
						autoComplete='off'
						count={{
							show: true,
							max: 30,
						}}></Input>
				</Form.Item>
				<Form.Item
					name="responsible"
					label={t('models.fishbone_branch.fields.responsible')}
					rules={[
						{
							max: 100,
							message:
								t("messages.form.max_length_exceeded_error", { length: 100 })
						}
					]}>
					<Input
						autoComplete='off'
						count={{
							show: true,
							max: 100,
						}}></Input>
				</Form.Item>
				<Form.Item name="description" label={t('models.fishbone_branch.fields.description')} rules={[
					{
						max: 500,
						message:
							t("messages.form.max_length_exceeded_error", { length: 500 })
					}
				]}>
					<Input.TextArea
						rows={5}
						count={{
							show: true,
							max: 500,
						}}></Input.TextArea>
				</Form.Item>
				<Flex>
					<Form.Item name="startOn" label={t('models.fishbone_branch.fields.startOn')} className="w-50">
						<DatePicker
							disabledDate={isDisabledDate}
							format="DD/MM/YYYY"
						></DatePicker>
					</Form.Item>
					<Form.Item name="endOn" label={t('models.fishbone_branch.fields.endOn')} className="w-50">
						<DatePicker
							disabledDate={isDisabledDate}
							format="DD/MM/YYYY"
						></DatePicker>
					</Form.Item>
				</Flex>
				<Form.Item name="evaluatedAt" label={t('models.indicator.fields.evaluated_at')}>
					<DatePicker format="DD/MM/YYYY" />
				</Form.Item>
				<Form.Item name="weight" label={t('models.fishbone_branch.fields.weight')}>
					<Slider
						tooltip={{ open: true, placement: 'bottom' }}
						dots={true}
						min={1}
						max={3}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default FishboneBranchEditionModal;
